import React from 'react';
import { bool, func } from 'prop-types';
import { ToggleBtn, Hamburger } from './Burger.styled';

const Burger = ({ openNav, setOpenNav, ...props }) => {

    const isExpanded = openNav ? true : false;
  
    return (
        <ToggleBtn aria-label="Toggle menu" aria-expanded={isExpanded} openNav={openNav} onClick={() => setOpenNav(!openNav)}>
            <Hamburger aria-hidden="true" openNav={openNav} />
        </ToggleBtn>
    )
}

Burger.propTypes = {
    openNav: bool.isRequired,
    setOpenNav: func.isRequired,
};

export default Burger;